import { z } from "zod"

export const BackofficeConversationSalesReportExportResponseDataSchema = z.object({
  success: z.boolean(),
})
